/**
 * Load More pagination for collection grids.
 * Fetches the next page's section HTML (?section_id=...), pulls out the new
 * product cards, and appends them into the existing grid — no full page
 * reload. Mirrors the pattern used by facet-filters-form in plp.js.
 *
 * Uses event delegation on document rather than binding listeners to
 * individual buttons: facet filtering / sorting (plp.js) replaces the whole
 * grid via innerHTML, which would silently drop a per-button listener and
 * leave the "Load more" button dead after any filter change.
 */
(function () {
  'use strict';

  var activeRequest = false;

  function setLoading(button, isLoading) {
    button.classList.toggle('loading', isLoading);
    button.disabled = isLoading;
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    var spinner = button.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
  }

  function handleResponse(button, wrapper, gridId, grid, requestedUrl, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newGrid = doc.getElementById(gridId);

    if (newGrid) {
      // Move each new product card into the live grid.
      Array.prototype.slice.call(newGrid.children).forEach(function (item) {
        grid.appendChild(item);
      });
    }

    var newButton = doc.querySelector('[data-load-more-button]');
    if (newButton && newButton.dataset.nextUrl) {
      // There's another page after this one — point the button at it.
      button.dataset.nextUrl = newButton.dataset.nextUrl;
      setLoading(button, false);
    } else {
      // That was the last page — remove the button entirely.
      wrapper.remove();
    }

    // Keep the address bar (and back button / reload) in sync with what's
    // actually loaded, without triggering a navigation.
    try {
      var cleanUrl = requestedUrl
        .replace(/([?&])section_id=[^&]*(&|$)/, function (match, p1, p2) {
          return p2 === '&' ? p1 : '';
        })
        .replace(/[?&]$/, '');
      history.replaceState(history.state, '', cleanUrl);
    } catch (error) {
      // Non-fatal — URL sync is a nicety, not a requirement.
    }

    grid.dispatchEvent(new CustomEvent('load-more:products-appended', { bubbles: true }));
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-load-more-button]');
    if (!button || button.disabled || activeRequest) return;

    event.preventDefault();

    var url = button.dataset.nextUrl;
    var gridId = button.dataset.gridId || 'product-grid';
    var grid = document.getElementById(gridId);
    var wrapper = button.closest('[data-load-more-wrapper]') || button.parentElement;
    if (!url || !grid) return;

    activeRequest = true;
    setLoading(button, true);

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Load more request failed: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        handleResponse(button, wrapper, gridId, grid, url, html);
      })
      .catch(function (error) {
        console.error(error);
        setLoading(button, false);
      })
      .finally(function () {
        activeRequest = false;
      });
  });
})();
